import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

const INITIAL_PAGE_INDEX = 0;
const INITIAL_PAGE_SIZE = 10;
const INITIAL_TOTAL_ITEMS = 0;

const initialState: PaginationLocalState = {
  pageIndex: INITIAL_PAGE_INDEX,
  pageSize: INITIAL_PAGE_SIZE,
  totalItems: INITIAL_TOTAL_ITEMS,
};
interface PaginationLocalState {
  pageIndex: number;
  pageSize: number;
  totalItems: number;
}
export const PaginationStore = signalStore(
  withState(initialState),

  withComputed(({ totalItems, pageSize, pageIndex }) => ({
    totalPages: computed(() => Math.max(1, Math.ceil(totalItems() / pageSize()))),
    pageOffset: computed(() => pageIndex() * pageSize()),
  })),

  withMethods(store => ({
    setTotalItems(totalItems: number): void {
      patchState(store, { totalItems });
    },

    setPageSize(pageSize: number): void {
      patchState(store, { pageSize });
    },

    setPageIndex(pageIndex: number): void {
      patchState(store, { pageIndex });
    },

    resetPageIndex(): void {
      patchState(store, { pageIndex: 0 });
    },

    getPagedData<T extends object>(data: readonly T[]): readonly T[] {
      const start = store.pageIndex() * store.pageSize();
      return data.slice(start, start + store.pageSize());
    },
  }))
);
